exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-listWrapper-2jMwN{container-type:inline-size;border:var(--border);border-radius:8px;overflow-x:auto}@container (min-width:560px){.style-cssmodule-listWrapper-2jMwN [data-type=address],.style-cssmodule-listWrapper-2jMwN [data-type=carparksLinked]{display:none}}@container (min-width:952px){.style-cssmodule-listWrapper-2jMwN [data-type=carparksLinked]{display:table-cell}}@container (min-width:1100px){.style-cssmodule-listWrapper-2jMwN [data-type=address] .label{display:table-cell}}.style-cssmodule-desktop-fp32I{display:none}.style-cssmodule-mobile-2zB2-{display:block}@container (min-width:770px){.style-cssmodule-desktop-fp32I{display:block}.style-cssmodule-mobile-2zB2-{display:none}}", ""]);

// exports
exports.locals = {
	"listWrapper": "style-cssmodule-listWrapper-2jMwN",
	"desktop": "style-cssmodule-desktop-fp32I",
	"mobile": "style-cssmodule-mobile-2zB2-"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/accounts/components/Accounts/style.cssmodule.css
// module id = 2547
// module chunks = 121